import React from "react";
import { Link } from "react-router-dom";

import { observer } from "mobx-react";
import { withStore } from "../../hocs";
import { HeaderMenu } from "./menu/HeaderMenu";
import { HeaderMenuTp } from "./menu/HeaderMenuTp";
import { SectionTopMenu } from "./menu/SectionTopMenu";
import { SearchTopForm } from "./SearchTopForm";

import { isMobile, AndroidView } from "react-device-detect";
import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Rating from "@mui/material/Rating";
import Typography from "@mui/material/Typography";
import Popup from "reactjs-popup";

// @ts-ignore
@withStore
@observer
export class HeaderTop extends React.Component {
  renderPopupModal() {
    // @ts-ignore
    const { store } = this.props;
    const { isOpenModal, onCloseModal, dataModal } = store?.pageMassageStore;

    return (
      <Popup
        open={isOpenModal}
        onClose={onCloseModal}
        modal
        nested
        trigger={<></>}
      >
        {(close) => (
          <div className="modal modal-basket">
            <div id="password-recovery-sent" className="white-popup-block">
              <div className="pas-recovery-wrapper">
                <div className="close-modal lightblue-square">
                  <p>
                    <span onClick={close} className="popup-modal-dismiss">
                      <img
                        src="/img/ico/basket-item/delete-item.svg"
                        alt="delete.svg"
                      />
                    </span>
                  </p>
                </div>
                <>
                  <div className="modal-img">
                    <div className="success-reg-img done__circle">
                      <svg
                        width="140"
                        height="140"
                        viewBox="0 0 38 38"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          width="38"
                          height="38"
                          rx="19"
                          fill="#FFE3B8"
                        ></rect>
                        <path
                          d="M19 9C13.4731 9 9 13.4725 9 19C9 24.5269 13.4725 29 19 29C24.5269 29 29 24.5275 29 19C29 13.4731 24.5275 9 19 9ZM19 27.6046C14.2554 27.6046 10.3954 23.7446 10.3954 19C10.3954 14.2554 14.2554 10.3954 19 10.3954C23.7446 10.3954 27.6046 14.2554 27.6046 19C27.6046 23.7446 23.7446 27.6046 19 27.6046Z"
                          fill="#F9A01F"
                        ></path>
                        <path
                          d="M18.9999 16.9535C18.6146 16.9535 18.3022 17.2659 18.3022 17.6511V23.3721C18.3022 23.7574 18.6146 24.0697 18.9999 24.0697C19.3852 24.0697 19.6976 23.7574 19.6976 23.3721V17.6512C19.6976 17.2659 19.3852 16.9535 18.9999 16.9535Z"
                          fill="#F9A01F"
                        ></path>
                        <path
                          d="M18.9999 13.9302C18.6146 13.9302 18.3022 14.2426 18.3022 14.6278V15.4651C18.3022 15.8504 18.6146 16.1627 18.9999 16.1627C19.3852 16.1627 19.6976 15.8503 19.6976 15.4651V14.6278C19.6976 14.2426 19.3852 13.9302 18.9999 13.9302Z"
                          fill="#F9A01F"
                        ></path>
                      </svg>
                    </div>
                  </div>

                  <div className="modal-description">
                    <p className="modal__description">
                      {dataModal?.description}
                      <br />
                      {dataModal?.href ? (
                        <a href={dataModal.href}>{dataModal.textHref}</a>
                      ) : null}
                    </p>
                  </div>
                </>

                <div className="btn-center-modal"></div>
              </div>
            </div>
          </div>
        )}
      </Popup>
    );
  }

  renderLogo() {
    return (
      <div className="logo">
        <Link to="/">
          <svg
            className="logo__img"
            width="199"
            height="76"
            viewBox="0 0 199 76"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M118.648 55.4043L110.013 35.7094C110.013 35.5339 109.844 35.3651 109.844 35.1895C109.668 35.014 109.668 34.8452 109.5 34.8452C108.98 34.1565 107.947 33.8122 107.258 33.8122H102.424C101.735 33.8122 101.384 34.3321 101.735 34.8452L113.996 60.7517C113.996 60.9272 114.165 61.096 114.165 61.2716C114.341 61.4471 114.341 61.6159 114.509 61.6159C115.198 62.3046 115.887 62.6489 116.751 62.6489H120.897C121.241 62.6489 121.585 62.6489 122.105 62.4734C122.274 62.4734 122.274 62.2978 122.449 62.2978C122.969 61.9535 123.489 61.4336 123.827 60.7449L126.595 54.8709L122.794 46.2354L118.648 55.4043Z"
              fill="#B0B1B1"
            />
            <path
              d="M83.5935 23.9682H78.4082C77.7195 23.9682 77.1996 24.4881 77.1996 25.3523V61.2784C77.1996 61.9671 77.7195 62.6625 78.4082 62.6625H83.5935C84.2822 62.6625 84.8021 62.1426 84.8021 61.2784V25.3523C84.7953 24.4881 84.2822 23.9682 83.5935 23.9682Z"
              fill="#B0B1B1"
            />
            <path
              d="M20.7211 39.6863C14.334 38.4777 9.15538 37.2691 9.15538 33.8122C9.15538 32.4281 9.67527 31.3951 10.7083 30.5309C11.7481 29.8422 13.1254 29.4911 15.0227 29.4911H23.4894C25.0423 29.4911 26.5952 29.8355 27.6349 30.3553C27.8105 30.5309 27.9793 30.5309 28.1548 30.6997C29.1946 31.2196 29.8833 32.0838 30.4032 33.1168C30.7475 33.981 31.2606 34.5009 31.6117 34.6697C32.1316 35.014 32.6515 35.1896 33.1646 35.1896H36.446C36.6215 35.1896 37.1347 35.014 37.4858 34.8453C37.8301 34.5009 38.1744 33.981 38.1744 33.1168C38.1744 30.3553 36.446 28.107 33.8533 26.3786C31.0918 24.6569 27.6349 23.6238 24.178 23.6238H16.9267C10.1884 23.6238 5.87403 24.8324 3.28135 26.7296C0.864225 28.6336 0 31.2196 0 34.5009C0 42.6165 10.5327 44.8649 18.9994 46.5933C25.3866 47.9774 30.7407 49.0104 30.7407 52.4673C30.7407 53.8515 30.2209 54.8845 29.1878 55.7487C28.1481 56.4374 26.7707 56.7817 24.8667 56.7817H15.1982C13.6453 56.7817 12.0924 56.4374 11.0526 55.9175C10.8838 55.7419 10.7083 55.7419 10.5327 55.5731C9.49297 55.0533 8.80429 54.189 8.29116 53.156C7.77127 52.4673 7.42693 51.7719 6.90705 51.6031C6.38716 51.2588 5.87403 51.0832 5.35414 51.0832H1.904C1.72845 51.0832 1.21532 51.2588 0.864225 51.4276C0.519885 51.7719 0.175546 52.2918 0.175546 53.156C0.175546 55.9175 1.904 58.1658 4.48992 59.8943C7.25814 61.6227 10.7083 62.6557 14.1652 62.6557H22.8007C29.5389 62.6557 33.8533 61.4472 36.446 59.5499C38.8631 57.6527 39.7273 55.06 39.7273 51.7787C39.7206 43.4807 29.1878 41.408 20.7211 39.6863Z"
              fill="#B0B1B1"
            />
            <path
              d="M91.358 62.6558H96.5434C97.2321 62.6558 97.7519 62.1359 97.7519 61.2717V25.5211C97.7519 24.8324 97.2321 24.137 96.5434 24.137H91.358C90.6693 24.137 90.1495 24.6569 90.1495 25.5211V61.4472C90.1562 62.1359 90.6693 62.6558 91.358 62.6558Z"
              fill="#B0B1B1"
            />
            <path
              d="M73.2294 47.282C73.2294 42.4478 71.852 38.8221 69.2594 36.3982C66.6667 33.981 62.6966 32.5969 57.8624 32.5969C53.0281 32.5969 49.0581 33.981 46.4654 36.3982C43.8727 38.9909 42.3198 42.6165 42.3198 47.6264C42.3198 52.6362 43.6972 56.2618 46.4654 58.8545C49.0581 61.4472 53.0281 62.6558 57.8624 62.6558C62.3523 62.6558 66.1535 62.1359 68.5707 60.9273C70.8123 59.8943 72.1964 58.1658 72.1964 55.5732C72.1964 55.3976 72.1964 55.2288 72.0208 55.0533C71.852 54.8777 71.6765 54.8777 71.5009 54.8777H67.1798C66.6599 54.8777 66.1468 55.0533 65.8025 55.2221C65.4581 55.3976 65.1138 55.742 64.7627 56.0863C64.5871 56.2618 64.4183 56.4306 64.074 56.775C63.8985 56.9505 63.5541 57.1193 63.3853 57.2949C62.1768 57.9835 60.2795 58.3279 58.3755 58.3279C55.7828 58.3279 53.7101 57.808 52.3327 56.4306C50.9486 55.2221 50.2599 53.3248 50.0844 50.7322V49.5236H72.5407C72.5407 49.6991 73.0606 49.348 73.0606 49.348C73.2361 49.1725 73.2361 49.0037 73.2361 48.8282V47.282H73.2294ZM50.0844 45.7291V44.6961V44.5205C50.0844 43.8319 50.2599 43.312 50.2599 42.6233C50.4355 42.1034 50.6042 41.4147 50.7798 40.8948C51.9884 38.1334 54.2367 36.7493 57.6936 36.7493C60.1107 36.7493 62.0147 37.4379 63.2165 38.8221C64.4251 40.2062 65.1205 42.1034 65.2893 44.5205V45.5536L50.0844 45.7291Z"
              fill="#B0B1B1"
            />
            <path
              d="M161.138 33.6366H155.959C155.264 33.6366 154.751 34.1565 154.751 35.0207V61.2716C154.751 61.9603 155.271 62.6557 155.959 62.6557H161.138C161.827 62.6557 162.347 62.1358 162.347 61.2716V35.0207C162.515 34.3321 161.827 33.6366 161.138 33.6366Z"
              fill="#B0B1B1"
            />
            <path
              d="M197.752 62.6559C197.928 62.6559 198.096 62.6559 198.272 62.4803C198.447 62.3048 198.447 62.136 198.447 61.9605V45.7292C198.447 41.2393 197.239 38.1267 195.166 36.0607C193.093 33.9879 190.156 33.1237 186.699 33.1237C184.627 33.1237 183.074 33.468 181.514 34.1567C179.961 34.8454 178.753 35.8852 177.375 36.9182C176.855 37.2625 176.335 37.9512 175.647 38.4711C175.647 37.6069 175.647 36.3983 175.647 36.2228V34.4943C175.647 34.3188 175.647 34.15 175.471 33.9744C175.296 33.7989 175.127 33.7989 174.951 33.7989H168.564C168.395 33.7989 168.22 33.7989 168.044 33.9744C167.869 34.15 167.869 34.3188 167.869 34.4943V61.9537C167.869 62.1292 167.869 62.298 168.044 62.4736C168.22 62.6491 168.389 62.6491 168.564 62.6491H174.951C175.127 62.6491 175.296 62.6491 175.471 62.4736C175.647 62.298 175.647 62.1292 175.647 61.9537V42.7922C176.335 41.5837 178.928 39.6864 179.617 39.3353C180.994 38.4711 182.554 37.9512 184.276 37.9512C186.18 37.9512 187.732 38.6399 188.934 39.8484C189.974 41.057 190.663 43.1298 190.663 45.7225V61.9605C190.663 62.136 190.663 62.3048 190.838 62.4803C191.014 62.6559 191.183 62.6559 191.358 62.6559H197.752Z"
              fill="#B0B1B1"
            />
            <path
              d="M15.8937 75.3289H22.1121V74.4646H16.9335V72.5674H21.9433V71.7032H16.9335V69.9747H22.1121V69.1105H15.8937V75.3289Z"
              fill="#B0B1B1"
            />
            <path
              d="M46.1145 69.1105H45.0747V75.3289H51.1176V74.4646H46.1145V69.1105Z"
              fill="#B0B1B1"
            />
            <path
              d="M67.6996 74.4646H67.5308L65.1137 69.1105H64.2495L62.0011 74.4646H61.8323L59.2397 69.1105H58.1999L61.3057 75.3289H62.5143L64.7558 70.3191L66.9974 75.3289H68.206L71.143 69.1105H70.1032L67.6996 74.4646Z"
              fill="#B0B1B1"
            />
            <path
              d="M3.80124 71.8786C1.55966 71.703 1.21532 71.5342 1.21532 70.8456C1.21532 70.1569 1.38411 69.9813 3.80124 69.9813C5.87403 69.9813 6.21837 70.1569 6.21837 71.1899H7.25814C7.25814 69.8058 6.9138 69.1171 3.80124 69.1171C0.864225 69.1171 0.175546 69.2927 0.175546 70.8456C0.175546 72.0541 0.519885 72.7428 3.80124 72.7428C6.39391 72.7428 6.39391 72.9184 6.39391 73.7826C6.39391 74.6468 5.87403 74.8156 3.63244 74.8156C1.21532 74.8156 1.03977 74.64 1.03977 73.4315H0C0 74.9844 0.175545 75.6798 3.62569 75.6798C6.38716 75.6798 7.42693 75.5043 7.42693 73.7826C7.42693 72.2229 7.08259 72.0474 3.80124 71.8786Z"
              fill="#B0B1B1"
            />
            <path
              d="M31.9493 69.1105H30.9163V75.3289H36.9591V74.4646H31.9493V69.1105V69.1105Z"
              fill="#B0B1B1"
            />
            <path
              d="M97.0632 74.6402L91.3648 69.1105H89.9806V75.3289H90.8449V69.9747L96.5434 75.3289H97.9275V69.1105H97.0632V74.6402Z"
              fill="#B0B1B1"
            />
            <path
              d="M81.0007 69.1105H79.9677V75.3289H81.0007V69.1105Z"
              fill="#B0B1B1"
            />
            <path
              d="M158.72 68.9416C155.263 68.9416 155.095 69.2859 155.095 72.2229C155.095 75.1599 155.615 75.5043 158.72 75.5043C162.002 75.5043 162.346 75.1599 162.346 72.2229C162.515 69.4615 162.171 68.9416 158.72 68.9416ZM158.72 74.64C156.128 74.64 155.959 74.1202 155.959 72.2229C155.959 69.9746 156.128 69.8058 158.72 69.8058C161.313 69.8058 161.489 69.9813 161.489 72.2229C161.482 74.2957 161.306 74.64 158.72 74.64Z"
              fill="#B0B1B1"
            />
            <path
              d="M197.064 69.1105H191.71V75.3289H192.749V73.0805H197.07C198.279 73.0805 198.968 72.5606 198.968 71.1833C198.961 69.6304 198.272 69.1105 197.064 69.1105ZM197.064 72.2231H192.743V69.9747H197.064C197.584 69.9747 197.928 70.3191 197.928 71.1833C197.928 71.8787 197.584 72.2231 197.064 72.2231Z"
              fill="#B0B1B1"
            />
            <path
              d="M143.866 71.1833C143.866 69.9747 143.346 69.1105 142.138 69.1105H136.264V75.3289H137.303V73.0805H141.962C142.482 73.0805 143.002 73.4249 143.002 73.7692V75.3221H144.042V73.7692C144.042 73.0805 143.522 72.7294 143.177 72.5606C143.353 72.5674 143.866 72.2231 143.866 71.1833ZM141.624 72.2231H137.135V69.9747H141.624C142.144 69.9747 142.833 70.1503 142.833 71.1833C142.826 72.2231 142.313 72.2231 141.624 72.2231Z"
              fill="#B0B1B1"
            />
            <path
              d="M121.241 69.8058C123.658 69.8058 124.01 69.8058 124.01 71.1899H125.049C125.049 69.1171 124.529 68.9416 121.424 68.9416C118.142 68.9416 117.798 69.2859 117.798 72.2229C117.798 74.9844 118.318 75.5043 121.424 75.5043C124.705 75.5043 125.049 75.1599 125.049 73.0871V72.2229H120.904V73.0871H124.01C124.01 74.64 123.834 74.64 121.241 74.64C118.655 74.64 118.48 74.64 118.48 72.2229C118.48 69.9746 118.655 69.8058 121.241 69.8058Z"
              fill="#B0B1B1"
            />
            <path
              d="M134.941 62.6558C133.037 62.6558 131.821 61.616 131.133 59.8876L137.885 47.7749C146.189 31.5032 164.365 -0.51363 164.196 0.00625505L142.901 59.8943C142.381 61.6228 140.997 62.6626 139.093 62.6626H134.941V62.6558Z"
              fill="url(#paint0_linear_1219:14200)"
            />
            <path
              d="M124.212 24.056C126.805 24.056 129.404 24.5759 130.62 28.0395L137.891 47.7681L142.908 59.8808C142.388 61.6092 141.004 62.649 139.1 62.649H134.947C133.043 62.649 131.828 61.6092 131.139 59.8808L116.259 26.8242C115.219 24.5759 116.603 24.056 118.163 24.056H124.212V24.056Z"
              fill="url(#paint1_linear_1219:14200)"
            />
            <path
              d="M179.617 69.1105V73.6004C179.617 74.4444 179.279 74.6267 177.031 74.6334C174.782 74.6267 174.438 74.4376 174.438 73.6004V69.1105H173.398V73.6004C173.398 73.9245 173.405 74.1946 173.439 74.4174C173.581 75.3896 174.222 75.4977 177.024 75.4977C179.826 75.4977 180.467 75.3829 180.609 74.4174C180.643 74.1946 180.65 73.9245 180.65 73.6004V69.1105H179.617Z"
              fill="#B0B1B1"
            />
            <defs>
              <linearGradient
                id="paint0_linear_1219:14200"
                x1="156.505"
                y1="-11.6404"
                x2="141.429"
                y2="59.2797"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#0090FF" />
                <stop offset="1" stopColor="#003760" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_1219:14200"
                x1="118.357"
                y1="18.4359"
                x2="142.587"
                y2="67.7641"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#0090FF" />
                <stop offset="1" stopColor="#0080DD" />
              </linearGradient>
            </defs>
          </svg>
        </Link>
      </div>
    );
  }

  renderMobileView() {
    // @ts-ignore
    const { store } = this.props;
    const { user, clientId } = store?.mainStore;

    let userName = "";
    let id = 0;
    if (user) {
      userName = user.email;
      id = parseInt(user.id);
    }
    const { includeUserLoyaltyProgram } = store?.mainStore;

    if (user?.type === "clientGuest" || !user) {
      return null;
    }

    return (
      <div className="display-mobile-flex top-mobile">
        <div className="top-mobile_item">
          <Link className="top-mobile_a" to={"/personal"}>
            <svg
              width="29"
              className="top-mobile_img"
              height="28"
              viewBox="0 0 29 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.5 2C21.1274 2 26.5 7.37258 26.5 14C26.5 20.6274 21.1274 26 14.5 26C7.87258 26 2.5 20.6274 2.5 14C2.5 7.37258 7.87258 2 14.5 2ZM14.5 20.5C12.4141 20.5 10.42 21.082 8.70321 22.149C10.3382 23.3146 12.339 24 14.5 24C16.6605 24 18.661 23.3148 20.296 22.15C18.5795 21.0818 16.5857 20.5 14.5 20.5ZM14.5 4C8.97715 4 4.5 8.47715 4.5 14C4.5 16.6157 5.50426 18.9968 7.14823 20.7788C9.28562 19.3082 11.831 18.5 14.5 18.5C17.1693 18.5 19.7149 19.3084 21.8527 20.7774C23.4961 18.9959 24.5 16.6152 24.5 14C24.5 8.47715 20.0228 4 14.5 4ZM14.5 7.5C17.1242 7.5 19.25 9.62584 19.25 12.25C19.25 14.8742 17.1242 17 14.5 17C11.8758 17 9.75 14.8742 9.75 12.25C9.75 9.62584 11.8758 7.5 14.5 7.5ZM14.5 9.5C12.9804 9.5 11.75 10.7304 11.75 12.25C11.75 13.7696 12.9804 15 14.5 15C16.0196 15 17.25 13.7696 17.25 12.25C17.25 10.7304 16.0196 9.5 14.5 9.5Z"
                fill="#074DB7"
              />
            </svg>
            <p className="top-mobile_text">Профиль</p>
          </Link>
        </div>
        {parseInt(clientId) ? (
          <>
            <div className="top-mobile_item">
              <Link className="top-mobile_a" to={"/message"}>
                <svg
                  width="29"
                  height="28"
                  viewBox="0 0 29 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.03663 13.4989C3.03663 7.83902 8.32565 3.5 14.5182 3.5C20.7108 3.5 25.9998 7.83902 25.9998 13.4989C25.9998 19.1589 20.7108 23.4979 14.5182 23.4979C13.1451 23.4979 11.8252 23.288 10.6002 22.9013C9.15538 24.2498 7.05607 24.898 4.48805 24.9989C3.44195 25.04 2.68689 23.9519 3.12492 22.978C3.74632 21.5866 4.54922 19.9915 4.64443 18.6002C3.62759 17.1195 3.03663 15.3721 3.03663 13.4989ZM14.5182 5.5C9.13315 5.5 5.03663 9.21891 5.03663 13.4989C5.03663 15.0359 5.55127 16.4778 6.45849 17.6996C6.58651 17.872 6.65563 18.081 6.65563 18.2957C6.65563 19.9295 6.00437 21.471 5.34121 22.9339C7.39728 22.7155 8.74611 22.0571 9.55946 21.1C9.83263 20.7786 10.2781 20.6631 10.6731 20.8114C11.8453 21.2516 13.1456 21.4979 14.5182 21.4979C19.9033 21.4979 23.9998 17.779 23.9998 13.4989C23.9998 9.21891 19.9033 5.5 14.5182 5.5Z"
                    fill="#074DB7"
                  />
                </svg>
                <p className="top-mobile_text">Сообщения</p>
              </Link>
            </div>
          </>
        ) : null}
        {includeUserLoyaltyProgram ? (
          <div className="top-mobile_item">
            <Link className="top-mobile_a" to={"/personal"}>
              <img src="/img/ico/bonusIcon.png" width="30px" />
              <p className="top-mobile_text" style={{ marginTop: 2 }}>
                Бонусы
              </p>
            </Link>
          </div>
        ) : (
          <div className="top-mobile_item">
            <a className="top-mobile_a" href={"tel:375293975737"}>
              <svg
                width="28"
                height="28"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.37704 15.5104C8.67847 18.2615 11.4489 20.4275 14.6109 21.9602C15.8148 22.5307 17.4248 23.2076 19.2186 23.3237C19.3298 23.3285 19.4362 23.3333 19.5474 23.3333C20.7513 23.3333 21.7183 22.9175 22.5063 22.0617C22.5112 22.0569 22.5208 22.0472 22.5257 22.0376C22.8061 21.6991 23.1252 21.3945 23.4588 21.0706C23.6861 20.853 23.9181 20.6258 24.1405 20.3937C25.1704 19.3203 25.1704 17.9569 24.1309 16.9174L21.2251 14.0116C20.7319 13.4991 20.1421 13.2283 19.5232 13.2283C18.9043 13.2283 18.3096 13.4991 17.802 14.0068L16.0711 15.7377C15.9115 15.6458 15.7471 15.5636 15.5924 15.4863C15.399 15.3896 15.2201 15.2977 15.0606 15.1962C13.4844 14.1953 12.0532 12.8899 10.685 11.2122C9.99356 10.3371 9.52941 9.60216 9.20547 8.85274C9.65996 8.44177 10.0854 8.01147 10.4964 7.59083C10.6414 7.44095 10.7913 7.29106 10.9412 7.14118C11.4634 6.61901 11.7438 6.01464 11.7438 5.40061C11.7438 4.78657 11.4682 4.18221 10.9412 3.66004L9.5004 2.21923C9.33118 2.05001 9.17163 1.88562 9.00724 1.7164C8.68814 1.38762 8.35453 1.04918 8.02575 0.744578C7.52775 0.256251 6.94273 0 6.32386 0C5.70982 0 5.11996 0.256251 4.60263 0.749413L2.79437 2.55767C2.13682 3.21522 1.76453 4.01299 1.68717 4.93646C1.5953 6.092 1.80804 7.32007 2.35922 8.80439C3.20533 11.101 4.48175 13.2332 6.37704 15.5104ZM2.86689 5.03799C2.92491 4.39494 3.17149 3.85827 3.63564 3.39412L5.43423 1.59552C5.71466 1.32477 6.02409 1.18456 6.32386 1.18456C6.61879 1.18456 6.91855 1.32477 7.19414 1.60519C7.51808 1.90496 7.82268 2.21923 8.15146 2.55284C8.31585 2.72206 8.48507 2.89128 8.65429 3.06534L10.0951 4.50615C10.3949 4.80591 10.5496 5.11051 10.5496 5.41028C10.5496 5.71004 10.3949 6.01464 10.0951 6.31441C9.94522 6.46429 9.79533 6.61901 9.64545 6.76889C9.1958 7.22337 8.77516 7.65368 8.31101 8.06465C8.30134 8.07432 8.29651 8.07915 8.28684 8.08882C7.88554 8.49012 7.94839 8.87208 8.04509 9.16218C8.04993 9.17668 8.05476 9.18635 8.0596 9.20086C8.43189 10.0953 8.94922 10.9463 9.75665 11.9616C11.2071 13.7505 12.735 15.1381 14.4175 16.2067C14.6254 16.342 14.8478 16.4484 15.0557 16.5548C15.2491 16.6515 15.428 16.7433 15.5876 16.8449C15.6069 16.8545 15.6214 16.8642 15.6408 16.8739C15.8003 16.9561 15.955 16.9948 16.1097 16.9948C16.4965 16.9948 16.748 16.7482 16.8301 16.666L18.6384 14.8577C18.9188 14.5773 19.2234 14.4274 19.5232 14.4274C19.8907 14.4274 20.1904 14.6546 20.379 14.8577L23.2944 17.7683C23.8746 18.3485 23.8698 18.9771 23.2799 19.5911C23.0769 19.8087 22.8641 20.0166 22.6369 20.2341C22.2984 20.5629 21.9455 20.9014 21.6264 21.2833C21.0704 21.8829 20.408 22.1633 19.5522 22.1633C19.47 22.1633 19.383 22.1584 19.3008 22.1536C17.7149 22.0521 16.2403 21.4332 15.1331 20.9062C12.1258 19.4509 9.4859 17.3864 7.29568 14.7659C5.49225 12.595 4.27869 10.574 3.47609 8.40793C2.97809 7.07833 2.78953 6.00981 2.86689 5.03799Z"
                  fill="#074DB7"
                />
                <path
                  d="M6.06064 16.0231C8.36206 18.7742 11.1325 20.9402 14.2945 22.4729C15.4984 23.0434 17.1084 23.7203 18.9022 23.8364C19.0134 23.8412 19.1198 23.846 19.231 23.846C20.4349 23.846 21.4018 23.4302 22.1899 22.5744C22.1948 22.5696 22.2044 22.5599 22.2093 22.5503C22.4897 22.2118 22.8088 21.9072 23.1424 21.5833C23.3697 21.3657 23.6017 21.1385 23.8241 20.9064C24.854 19.833 24.854 18.4696 23.8145 17.4301L20.9087 14.5243C20.4155 14.0118 19.8257 13.741 19.2068 13.741C18.5879 13.741 17.9932 14.0118 17.4856 14.5195L15.7547 16.2504C15.5951 16.1585 15.4307 16.0763 15.276 15.999C15.0826 15.9023 14.9037 15.8104 14.7442 15.7089C13.168 14.708 11.7368 13.4026 10.3686 11.7249C9.67716 10.8498 9.21301 10.1149 8.88907 9.36544C9.34355 8.95447 9.76902 8.52416 10.18 8.10352C10.325 7.95364 10.4749 7.80376 10.6248 7.65387C11.147 7.1317 11.4274 6.52734 11.4274 5.9133C11.4274 5.29927 11.1518 4.6949 10.6248 4.17273L9.184 2.73192C9.01477 2.5627 8.85522 2.39831 8.69083 2.22909C8.37173 1.90032 8.03812 1.56187 7.70934 1.25727C7.21135 0.768946 6.62632 0.512695 6.00745 0.512695C5.39342 0.512695 4.80356 0.768946 4.28622 1.26211L2.47796 3.07037C1.82041 3.72792 1.44812 4.52568 1.37076 5.44915C1.2789 6.6047 1.49163 7.83277 2.04282 9.31709C2.88893 11.6137 4.16535 13.7459 6.06064 16.0231ZM2.55048 5.55068C2.6085 4.90764 2.85508 4.37096 3.31924 3.90681L5.11783 2.10822C5.39825 1.83746 5.70769 1.69725 6.00745 1.69725C6.30238 1.69725 6.60215 1.83746 6.87774 2.11789C7.20168 2.41765 7.50628 2.73192 7.83505 3.06553C7.99944 3.23476 8.16866 3.40398 8.33788 3.57804L9.77869 5.01884C10.0785 5.31861 10.2332 5.62321 10.2332 5.92297C10.2332 6.22274 10.0785 6.52734 9.77869 6.8271C9.62881 6.97699 9.47893 7.1317 9.32904 7.28159C8.8794 7.73607 8.45876 8.16638 7.99461 8.57735C7.98494 8.58702 7.9801 8.59185 7.97043 8.60152C7.56913 9.00282 7.63199 9.38478 7.72868 9.67487C7.73352 9.68938 7.73836 9.69905 7.74319 9.71355C8.11548 10.608 8.63282 11.459 9.44025 12.4743C10.8907 14.2632 12.4186 15.6508 14.1011 16.7194C14.309 16.8547 14.5314 16.9611 14.7393 17.0675C14.9327 17.1642 15.1116 17.256 15.2712 17.3576C15.2905 17.3672 15.305 17.3769 15.3243 17.3866C15.4839 17.4688 15.6386 17.5074 15.7933 17.5074C16.1801 17.5074 16.4315 17.2609 16.5137 17.1787L18.322 15.3704C18.6024 15.09 18.907 14.9401 19.2068 14.9401C19.5742 14.9401 19.874 15.1673 20.0626 15.3704L22.978 18.281C23.5582 18.8612 23.5534 19.4898 22.9635 20.1038C22.7605 20.3214 22.5477 20.5293 22.3205 20.7468C21.982 21.0756 21.6291 21.4141 21.31 21.796C20.754 22.3956 20.0916 22.676 19.2358 22.676C19.1536 22.676 19.0666 22.6711 18.9844 22.6663C17.3985 22.5648 15.9239 21.9459 14.8167 21.4189C11.8094 19.9636 9.16949 17.8991 6.97927 15.2785C5.17585 13.1077 3.96228 11.0867 3.15968 8.92062C2.66169 7.59102 2.47312 6.5225 2.55048 5.55068Z"
                  fill="#074DB7"
                />
              </svg>
              <p className="top-mobile_text">Позвонить</p>
            </a>
          </div>
        )}
        <div className="top-mobile_item">
          <p className="top-mobile_a" onClick={() => store.authStore.logout()}>
            <svg
              width="28"
              height="28"
              viewBox="0 0 31 31"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.5072 30.0833H7.38178C3.81762 30.0833 0.916992 27.1827 0.916992 23.6156V7.38579C0.916992 3.81871 3.81762 0.916626 7.38178 0.916626H14.4912C18.0582 0.916626 20.9603 3.81871 20.9603 7.38579V8.74496C20.9603 9.34871 20.4703 9.83871 19.8666 9.83871C19.2628 9.83871 18.7728 9.34871 18.7728 8.74496V7.38579C18.7728 5.02329 16.8522 3.10413 14.4912 3.10413H7.38178C5.02366 3.10413 3.10449 5.02329 3.10449 7.38579V23.6156C3.10449 25.9766 5.02366 27.8958 7.38178 27.8958H14.5072C16.858 27.8958 18.7728 25.9825 18.7728 23.6316V22.2564C18.7728 21.6527 19.2628 21.1627 19.8666 21.1627C20.4703 21.1627 20.9603 21.6527 20.9603 22.2564V23.6316C20.9603 27.19 18.0641 30.0833 14.5072 30.0833Z"
                fill="#074DB7"
              />
              <mask
                id="mask0_1113:374"
                maskUnits="userSpaceOnUse"
                x="11"
                y="14"
                width="20"
                height="3"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.1191 14.4062H30.8663V16.5938H11.1191V14.4062Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_1113:374)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M29.7727 16.5938H12.2129C11.6091 16.5938 11.1191 16.1038 11.1191 15.5C11.1191 14.8963 11.6091 14.4062 12.2129 14.4062H29.7727C30.3764 14.4062 30.8664 14.8963 30.8664 15.5C30.8664 16.1038 30.3764 16.5938 29.7727 16.5938Z"
                  fill="#074DB7"
                />
              </g>
              <mask
                id="mask1_1113:374"
                maskUnits="userSpaceOnUse"
                x="24"
                y="10"
                width="7"
                height="11"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M24.4097 10.1555H30.8662V20.8462H24.4097V10.1555Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask1_1113:374)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M25.5031 20.8462C25.2231 20.8462 24.9416 20.7397 24.7287 20.5239C24.3028 20.0952 24.3043 19.4039 24.7316 18.9781L28.2228 15.4999L24.7316 12.0233C24.3043 11.5974 24.3014 10.9062 24.7287 10.4774C25.1545 10.0487 25.8458 10.0487 26.2745 10.4745L30.5445 14.7256C30.7516 14.9297 30.8668 15.2097 30.8668 15.4999C30.8668 15.7902 30.7516 16.0702 30.5445 16.2743L26.2745 20.5268C26.0616 20.7397 25.7816 20.8462 25.5031 20.8462Z"
                  fill="#074DB7"
                />
              </g>
            </svg>
            <p className="top-mobile_text">Выйти</p>
          </p>
        </div>
      </div>
    );
  }

  renderAuthLogin() {
    //@ts-ignore
    const { store } = this.props;
    const { user } = store?.mainStore;
    if (!user) {
      return null;
    }
    let userName = "";
    if (user) {
      userName = user.email;
    }



    


    if (user?.type === "clientGuest") {
      return (
        <div className="menu__item __white-circle">
          <Link className="tooltip" to="/login">
            <img src="/img/ico/account.svg" alt="account.svg" />
            {userName ? (
              <span className="tooltiptext user">Авторизоваться</span>
            ) : null}
          </Link>
        </div>
      );
    }

    return <>
      <div className="menu__item __white-circle">
        <Link className="tooltip" to="/personal">
          <img src="/img/ico/account.svg" alt="account.svg" />
          {userName ? (
            <span className="tooltiptext user">{userName}</span>
          ) : null}
        </Link>
      </div>

      <div className="menu__item">
        <span className="tooltip" onClick={() => store.authStore.logout()}>
          <img src="/img/ico/Logout.svg" alt="logout.svg" />
          <span className="tooltiptext">Выход</span>
        </span>
      </div>
    </>;
  }

  renderUserSection() {
    //@ts-ignore
    const { store } = this.props;
    const { templateTp, user } = store?.mainStore;
    if (user?.type === "clientGuest" || !user) {
      return null;
    }
    return templateTp ? <HeaderMenuTp /> : <HeaderMenu />;
  }

  render() {
    // @ts-ignore
    const { store } = this.props;
    const { user, clientId } = store?.mainStore;
    const { count } = store?.componentBasketCountStore;
    const { countShowTop } = store?.pageMassageStore;
    let userName = "";
    let id = 0;
    if (user) {
      userName = user.email;
      id = parseInt(user.id);
    }

    let Width = window.innerWidth;
    const { scoresAmount, includeUserLoyaltyProgram } = store?.mainStore;

    let string = String(scoresAmount);

    if (user?.type === "clientGuest") {
      id = 0;
    }

    return (
      <>
        <header>
          {this.renderPopupModal()}
          <div className="container">
            <div className="header-top">
              <div className="sidebar">
                {this.renderLogo()}
                {this.renderMobileView()}
              </div>
              <div className="content header-content">
                {this.renderUserSection()}
                <div className="phone-number">
                  <div className="phone">
                    <div className="phone-logo">
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_239:6771)">
                          <path
                            d="M5.70538 18.6125C8.46709 21.9138 11.7916 24.5131 15.586 26.3523C17.0307 27.0369 18.9627 27.8492 21.1152 27.9884C21.2487 27.9942 21.3763 28 21.5098 28C22.9544 28 24.1148 27.501 25.0605 26.4741C25.0663 26.4683 25.0779 26.4567 25.0837 26.4451C25.4203 26.039 25.8032 25.6734 26.2035 25.2847C26.4762 25.0236 26.7547 24.7509 27.0216 24.4724C28.2574 23.1844 28.2574 21.5483 27.01 20.3009L23.523 16.8139C22.9312 16.1989 22.2234 15.874 21.4808 15.874C20.7381 15.874 20.0245 16.1989 19.4153 16.8081L17.3382 18.8852C17.1467 18.775 16.9495 18.6763 16.7638 18.5835C16.5317 18.4675 16.3171 18.3572 16.1256 18.2354C14.2342 17.0344 12.5168 15.4679 10.8749 13.4546C10.0452 12.4045 9.48822 11.5226 9.0995 10.6233C9.64488 10.1301 10.1554 9.61376 10.6486 9.10899C10.8227 8.92913 11.0025 8.74927 11.1824 8.56942C11.809 7.94281 12.1455 7.21757 12.1455 6.48073C12.1455 5.74389 11.8148 5.01865 11.1824 4.39204L9.45341 2.66308C9.25035 2.46001 9.05888 2.26274 8.86162 2.05968C8.47869 1.66515 8.07836 1.25901 7.68383 0.893494C7.08623 0.307501 6.3842 0 5.64156 0C4.90472 0 4.19688 0.307501 3.57608 0.899295L1.40617 3.06921C0.617109 3.85827 0.170362 4.81558 0.0775312 5.92375C-0.032705 7.3104 0.222579 8.78409 0.883996 10.5653C1.89933 13.3212 3.43103 15.8798 5.70538 18.6125ZM1.4932 6.04559C1.56282 5.27393 1.85872 4.62992 2.4157 4.07294L4.57401 1.91463C4.91052 1.58972 5.28184 1.42147 5.64156 1.42147C5.99548 1.42147 6.35519 1.58972 6.6859 1.92623C7.07463 2.28595 7.44015 2.66308 7.83468 3.06341C8.03195 3.26647 8.23501 3.46954 8.43808 3.67841L10.167 5.40738C10.5268 5.76709 10.7124 6.13262 10.7124 6.49233C10.7124 6.85205 10.5268 7.21757 10.167 7.57729C9.98719 7.75715 9.80733 7.94281 9.62747 8.12267C9.08789 8.66805 8.58313 9.18442 8.02614 9.67758C8.01454 9.68918 8.00874 9.69499 7.99713 9.70659C7.51558 10.1881 7.591 10.6465 7.70704 10.9946C7.71284 11.012 7.71864 11.0236 7.72444 11.041C8.17119 12.1144 8.79199 13.1355 9.76091 14.3539C11.5015 16.5006 13.3349 18.1658 15.354 19.448C15.6034 19.6104 15.8703 19.7381 16.1198 19.8657C16.3519 19.9818 16.5665 20.092 16.758 20.2138C16.7812 20.2254 16.7986 20.237 16.8218 20.2487C17.0133 20.3473 17.199 20.3937 17.3846 20.3937C17.8488 20.3937 18.1505 20.0978 18.2491 19.9992L20.419 17.8293C20.7555 17.4927 21.121 17.3129 21.4808 17.3129C21.9217 17.3129 22.2814 17.5856 22.5077 17.8293L26.0063 21.322C26.7025 22.0182 26.6967 22.7725 25.9888 23.5093C25.7452 23.7704 25.4899 24.0199 25.2172 24.281C24.8111 24.6755 24.3875 25.0816 24.0046 25.54C23.3374 26.2594 22.5425 26.5959 21.5156 26.5959C21.4169 26.5959 21.3125 26.5901 21.2139 26.5843C19.3109 26.4625 17.5413 25.7199 16.2126 25.0874C12.6038 23.3411 9.43601 20.8637 6.80774 17.719C4.64363 15.114 3.18735 12.6888 2.22424 10.0895C1.62664 8.49399 1.40037 7.21177 1.4932 6.04559Z"
                            fill="#074DB7"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_239:6771">
                            <rect width="28" height="28" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="phone-text">
                      <a href="tel:375172693333">+375 (17) 269-33-33</a>
                      <p className="little-phonetext">городской</p>
                    </div>
                  </div>
                  <div className="phone">
                    <div className="phone-logo">
                      <svg
                        width="16"
                        height="28"
                        viewBox="0 0 16 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.75"
                          y="0.75"
                          width="14.5"
                          height="26.5"
                          rx="2.25"
                          stroke="#074DB7"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M5.5 4L3.5 1H9H13L11 4H5.5Z"
                          stroke="#074DB7"
                          strokeWidth="1.5"
                        />
                        <rect
                          x="4"
                          y="24"
                          width="8"
                          height="1.5"
                          rx="0.75"
                          fill="#074DB7"
                        />
                      </svg>
                    </div>

                    <div className="phone-text">
                      <a href="tel:375293975737">+375 (29) 397-57-37</a>
                      <p className="little-phonetext">A1 </p>
                    </div>
                  </div>
                </div>
                {id ? (
                  <div className="nav-order">
                    <div className="order">
                      <svg
                        className="order__title__img"
                        width="19"
                        height="26"
                        viewBox="0 0 19 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask id="path-1-inside-1_239:6755" fill="white">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M13 0L19 6L19 5.99997V24C19 25.1046 18.1046 26 17 26H2C0.895431 26 0 25.1046 0 24V2C0 0.89543 0.895431 0 2 0H13Z"
                          />
                        </mask>
                        <path
                          d="M19 6L17.9393 7.06066L18.8109 7.93224L19.8349 7.24615L19 6ZM13 0L14.0606 -1.06066L13.6213 -1.5H13V0ZM19 5.99997H20.5V3.18941L18.1651 4.75381L19 5.99997ZM20.0606 4.93934L14.0606 -1.06066L11.9393 1.06066L17.9393 7.06066L20.0606 4.93934ZM18.1651 4.75381L18.165 4.75385L19.8349 7.24615L19.8349 7.24612L18.1651 4.75381ZM17.5 5.99997V24H20.5V5.99997H17.5ZM17.5 24C17.5 24.2761 17.2761 24.5 17 24.5V27.5C18.933 27.5 20.5 25.933 20.5 24H17.5ZM17 24.5H2V27.5H17V24.5ZM2 24.5C1.72386 24.5 1.5 24.2761 1.5 24H-1.5C-1.5 25.933 0.0670034 27.5 2 27.5V24.5ZM1.5 24V2H-1.5V24H1.5ZM1.5 2C1.5 1.72386 1.72386 1.5 2 1.5V-1.5C0.0670036 -1.5 -1.5 0.0670031 -1.5 2H1.5ZM2 1.5H13V-1.5H2V1.5Z"
                          fill="#074DB7"
                          mask="url(#path-1-inside-1_239:6755)"
                        />
                        <mask id="path-3-inside-2_239:6755" fill="white">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M13 0H12L12 4.99999C12 6.10457 12.8954 7 14 7H19V5.99999L13 0Z"
                          />
                        </mask>
                        <path
                          d="M12 0V-1.5H10.5L10.5 -3.45874e-06L12 0ZM13 0L14.0607 -1.06066L13.6213 -1.5H13V0ZM12 4.99999L13.5 5V5L12 4.99999ZM19 7V8.5H20.5V7H19ZM19 5.99999H20.5V5.37867L20.0607 4.93933L19 5.99999ZM12 1.5H13V-1.5H12V1.5ZM13.5 5L13.5 3.45874e-06L10.5 -3.45874e-06L10.5 4.99999L13.5 5ZM14 5.5C13.7239 5.5 13.5 5.27614 13.5 5L10.5 4.99999C10.5 6.93299 12.067 8.5 14 8.5V5.5ZM19 5.5H14V8.5H19V5.5ZM17.5 5.99999V7H20.5V5.99999H17.5ZM20.0607 4.93933L14.0607 -1.06066L11.9393 1.06066L17.9393 7.06065L20.0607 4.93933Z"
                          fill="#074DB7"
                          mask="url(#path-3-inside-2_239:6755)"
                        />
                        <rect
                          x="4"
                          y="9"
                          width="11"
                          height="1.5"
                          rx="0.75"
                          fill="#074DB7"
                        />
                        <rect
                          x="4"
                          y="13"
                          width="11"
                          height="1.5"
                          rx="0.75"
                          fill="#074DB7"
                        />
                        <rect
                          x="4"
                          y="17"
                          width="11"
                          height="1.5"
                          rx="0.75"
                          fill="#074DB7"
                        />
                      </svg>
                      <a className="order__title" href="/order">
                        Заказы
                      </a>
                    </div>
                    <div className="application">
                      <a className="application__title" href="/return">
                        Заявки на возврат
                      </a>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <div className="light-blue">
            <div className="container ">
              <div className="header-bottom">
                <SectionTopMenu />
                <div className="content header-content">
                  <SearchTopForm />
                  <div className="menu" style={{ width: "40%" }}>
                    {parseInt(clientId) ? (
                      <>
                        {includeUserLoyaltyProgram ? (
                          <div className="menu__item __white-circle">
                            <Link className="tooltip" to="/personal">
                              <img src="/img/ico/bonusIcon.png" width="30px" />
                              <span className="tooltiptext">
                                Бонусные баллы
                              </span>
                              <span
                                className="count-text-basket"
                                style={
                                  String(scoresAmount).length > 4
                                    ? {
                                        width:
                                          25 +
                                          Math.round(
                                            String(scoresAmount).length / 5
                                          ) *
                                            15,
                                      }
                                    : { width: "25px" }
                                }
                              >
                                {scoresAmount}
                              </span>
                            </Link>
                          </div>
                        ) : null}
                        {user?.type === "clientGuest" ? null : (
                          <div className="menu__item __white-circle">
                            <Link className="tooltip" to="/basket">
                              <img
                                src="/img/ico/shopping_cart.svg"
                                alt="shopping_cart.svg"
                              />
                              <span className="tooltiptext">Корзина</span>
                              <span className="count-text-basket">{count}</span>
                            </Link>
                          </div>
                        )}
                        {user?.type === "clientGuest" ? null : (
                          <div className="menu__item __white-circle">
                            <Link className="tooltip" to="/message">
                              <img src="/img/ico/Mail.svg" alt="main.svg" />
                              <span className="tooltiptext">Сообщения</span>
                              <span className="count-text-basket">
                                {countShowTop}
                              </span>
                            </Link>
                          </div>
                        )}
                      </>
                    ) : null}
                    {this.renderAuthLogin()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </>
    );
  }
}
